import { useContext } from "react";
import { DasboardContext } from "../../context/dashboard-context";

import Breadcrumb from "../../components/Breadcrumb/BreadCrumb";
import DeviceTable from "../Devices/Devices";

import useGetData from "../../hooks/useGetData";
import Layout from "../../components/Layout";

const DeviceList = () => {
  const { sidebarOpen } = useContext(DasboardContext);

  return (
    <Layout>
      <div className={`device-wrapper ${sidebarOpen ? "" : "close"}`}>
        <DeviceTable />
      </div>
    </Layout>
  );
};

export default DeviceList;
